import { appInsights } from 'utils/telemetry/app-insights';
import { authLegacyApiService } from 'api/auth-legacy/auth.legacy.api.service';
import { clearRememberedLogin } from 'utils/remembered-login';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const logOut = createAsyncThunk<boolean, { totalProductCount: number }>(
  'auth/log-out',
  async ({ totalProductCount }) => {
    await authLegacyApiService.logOut(totalProductCount);
    clearRememberedLogin();
    appInsights.trackEvent({ name: 'Logged out' });
    return true;
  },
);
